import { useContext } from 'react';
import { Context } from './Provider';

const useProps = () => {
    const params = useContext(Context);
    return params;
};

export default useProps;
